<template>
	<div class="wrapper">
		<button
			@click="submit"
			class="button is-primary fullwidth-mobile"
			:disabled="!isNextDisabled"
		>
			<span>Next Question</span>
		</button>
	</div>
</template>

<script lang="ts">
import { QuizActions } from '@/store/modules/quiz/actions';
import { STATE_MODULES } from '@/store/state-modules';
import { QuestionPropMixin } from '@/utils/skill-assessment-mixins';
import { AnsweredQuestion } from '@puls/puls-common-constants';
import { defineComponent } from 'vue'

export default defineComponent({
	mixins: [QuestionPropMixin],
	methods: {
		submit () {
			this.$store.dispatch(`${STATE_MODULES.QUIZ}/${QuizActions.SUBMIT_ANSWER}`, { uuid: this.question.uuid })
		}
	},
	computed: {
		isNextDisabled (): boolean {
			return !!(this.question as AnsweredQuestion).answers?.length
		}
	}
})
</script>

<style scoped>
	.wrapper{
		text-align: right;
	}
	@media (max-width: 768px) {
		.fullwidth-mobile {
			width: 100%;
		}
	}
</style>
